import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Pill } from "@/components/Common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle } from "./AdminLayout";
import { EventPicker } from "./EventPicker";

export default function Attendance() {
  const [eid, setEid] = useState(null);
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/attendance", { params: { event_id: eid || undefined } }).then((r) => setItems(r.data.items));
  }, [eid]);
  const manual = items.filter((i) => i.method === "MANUAL").length;
  return (
    <div>
      <PageTitle title="Kehadiran" desc={`${items.length} check-in · ${manual} manual override. Kehadiran ≠ jumlah climbing.`}>
        <EventPicker value={eid} onChange={setEid} allowAll testid="attendance-event-picker" />
      </PageTitle>
      <div className="overflow-x-auto rounded-2xl bg-white ring-1 ring-[#1A3323]/10">
        <Table data-testid="attendance-table">
          <TableHeader><TableRow><TableHead>Peserta</TableHead><TableHead>Event</TableHead><TableHead>Waktu</TableHead><TableHead>Metode</TableHead><TableHead>Jarak</TableHead><TableHead>Keeper / Alasan</TableHead><TableHead>Climb selesai</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((i) => (
              <TableRow key={i.id}>
                <TableCell className="font-semibold">{i.participant}<div className="text-xs font-normal text-muted-foreground">{i.city}</div></TableCell>
                <TableCell>{i.event_name}</TableCell>
                <TableCell className="text-xs">{fmtDateTime(i.checked_in_at)}</TableCell>
                <TableCell><Pill className={i.method === "MANUAL" ? "bg-orange-100 text-orange-900" : "bg-green-100 text-green-900"}>{i.method}</Pill></TableCell>
                <TableCell className="font-mono text-xs">{i.distance_m != null ? `${i.distance_m} m` : "-"}</TableCell>
                <TableCell className="text-xs">{i.keeper_name ? `${i.keeper_name}: ${i.reason}` : "-"}</TableCell>
                <TableCell className="font-mono">{i.completed}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
